const Config = {
    tomviz: {
        logo: "/PlantViz_images/TomViz_logo.svg",
        header: "/PlantViz_images/TomViz_header.svg",
        color: "bg-red-800",
        url: "/tomviz",
        text: "Solanum lycopersicum",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Function associations represented as Gene Cards with references and all the information from the most recent version of the catalogue. Includes an interactive organ expression viewer thorough all SRA runs available.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "http://plantaeviz.tomsbiolab.com/tomviz/catalogue"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use Expression Atlases App to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    pseudomonas_atlas: {
                        name: "Pseudomonas atlas",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/pseudomonas_atlas"
                    },
                    terpineol_atlas: {
                        name: "Terpineol atlas",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/terpineol_atlas"
                    }
                }
            },
            agg_gcns: {
                title: "Agg GCN App",
                description: "Aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes. Aggregation typically improves network performance but requires larger datasets (Orduña et al. 2023), tissues missing here may be found in non aggregated GCNs.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/leaf"
                    },
                    bud: {
                        name: "bud",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/bud"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/flower"
                    },
                    CI: {
                        name: "CI",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/CI"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/root"
                    },
                    fruit: {
                        name: "fruit",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/fruit"
                    }
                }
            },
            non_agg_gcns: {
                title: "Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    seedling: {
                        name: "seedling",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/seedling"
                    },
                    embryo: {
                        name: "embryo",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/embryo"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/seed"
                    },
                    cellculture: {
                        name: "cellculture",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/cellculture"
                    },
                    stem: {
                        name: "stem",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/stem"
                    },
                    pollen: {
                        name: "pollen",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/pollen"
                    },
                    trichomes: {
                        name: "trichomes",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/trichomes"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/vasculature"
                    }
                }
            },
            igrns: {
                title: "Inferred GRN App",
                description: "Inferred gene regulatory networks. Noise-filtered output from GENIE3.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/leaf"
                    },
                    fruit: {
                        name: "fruit",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/fruit"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/flower"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/seed"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/root"
                    }
                }
            },
            grns: {
                title: "rGRN App",
                description: "Reference gene regulatory networks (rGRNs) from organ-specific and condition-independent RNA-seq datsets complemented with gene co-expression and TF-binding predictions on open chromatin sites. Users may obtain lists of regulatory pairs of TF and target genes and visualize subnetworks using specific gene sets.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/grns/leaf"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/grns/flower"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/grns/seed"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/grns/root"
                    },
                    fruit: {
                        name: "fruit",
                        link: "http://plantaeviz.tomsbiolab.com/tomviz/networks/grns/fruit"
                    }
                }
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genome, transcriptome and proteome using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4502"
            },
            DAPBrowse: {
                title: "DAP-Browse App",
                description: "Browse through DAP-Seq data associated to the ITAG4 genome assembly for different transcription factors.",
                image: "/PlantViz_images/Vitviz_apps/DAPBrowse_banner.png",
                link: "http://147.156.206.251/test/?data=mydata%2FTomato&loc=SL4.0ch02%3A35884881..35900800&tracks=DNA%2CMYC2r_peaks%2CMYC2r2_peaks%2CMYC2_peaks%2CChip-MYC2_peaks%2Cannotations%2CHSFA1a_2_peaks%2CHsfA2_peaks%2CHsfA7_peaks%2CMYB21_peaks%2CMYB24_peaks%2CMYB70_peaks&highlight="
            },
            ExpressionOntology: {
                title: "Expression Ontology",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "http://plantaeviz.tomsbiolab.com/tomviz/expression_ontology"
            }
        }
    },
    mulviz: {
        logo: "/PlantViz_images/MorViz_logo.svg",
        header: "/PlantViz_images/MorViz_header.svg",
        color: "bg-purple-800",
        url: "/mulviz",
        text: "Morus alba",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Function associations represented as Gene Cards with references and all the information from the most recent version of the catalogue. Includes an interactive organ expression viewer thorough all SRA runs available.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "http://plantaeviz.tomsbiolab.com/mulviz/catalogue"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use Expression Atlases App to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    morus_atlas: {
                        name: "Morus atlas",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/morus_atlas"
                    },
                    morus_meja_atlas: {
                        name: "MeJA atlas",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/morus_meja_atlas"
                    },
                    fruit_flower_morus_atlas: {
                        name: "Fruit & flower",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/fruit_flower_morus_atlas"
                    }
                }
            },
            agg_gcns: {
                title: "Agg GCN App",
                description: "Aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes. Aggregation typically improves network performance but requires larger datasets (Orduña et al. 2023), tissues missing here may be found in non aggregated GCNs.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    CI: {
                        name: "CI",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/agg_gcns/CI"
                    }
                }
            },
            non_agg_gcns: {
                title: "Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    fruit: {
                        name: "fruit",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/fruit"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/leaf"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/flower"
                    },
                    stem: {
                        name: "stem",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/stem"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/root"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/vasculature"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/seed"
                    }
                }
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genome, transcriptome and proteome using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4500"
            },
            ExpressionOntology: {
                title: "Expression Ontology",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "http://plantaeviz.tomsbiolab.com/mulviz/expression_ontology"
            }
        }
    },
    vitviz: {
        logo: "/PlantViz_images/VitViz_logo.svg",
        header: "/PlantViz_images/VitViz_header.svg",
        color: "bg-vitviz",
        url: "/vitviz",
        text: "Vitis vinifera",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Function associations represented as Gene Cards with references and all the information from the most recent version of the catalogue. Includes an interactive organ expression viewer thorough all SRA runs available.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "http://plantaeviz.tomsbiolab.com/vitviz/catalogue"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use Expression Atlases App to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    Corvina: {
                        name: "Corvina",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/corvina_atlas"
                    },
                    Flower: {
                        name: "Flower",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/flower_atlas"
                    },
                    Berry: {
                        name: "Berry development",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/berry_atlas"
                    },
                    Circadian: {
                        name: "Circadian Rhythm",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/circadian_rhythm_app"
                    }
                }
            },
            T2T_non_agg_gcns: {
                title: "T2T Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    vasculature: {
                        name: "vasculature",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/vasculature"
                    }
                }
            },
            v3_non_agg_gcns: {
                title: "v3 Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/flower"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/root"
                    },
                    tendril: {
                        name: "tendril",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/tendril"
                    },
                    cellculture: {
                        name: "cellculture",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/cellculture"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/vasculature"
                    },
                    wood: {
                        name: "wood",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/wood"
                    },
                    stem: {
                        name: "stem",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/stem"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/leaf"
                    },
                    pericarp: {
                        name: "pericarp",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/pericarp"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/seed"
                    },
                    embryo: {
                        name: "embryo",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/embryo"
                    },
                    bud: {
                        name: "bud",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/bud"
                    }
                }
            },
            v3_igrns: {
                title: "v3 Inferred GRN App",
                description: "Inferred gene regulatory networks. Noise-filtered output from GENIE3.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    berry: {
                        name: "berry",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/berry"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/root"
                    },
                    pericarp: {
                        name: "pericarp",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/pericarp"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/leaf"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all SRA-Seq runs available in NCBI SRA database.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "http://plantaeviz.tomsbiolab.com/vitviz/expacrossnetworks"
            },
            DAPBrowse: {
                title: "DAP-Browse App",
                description: "Browse through DAP-Seq data associated to the PN40024.2 genome assembly for different transcription factors.",
                image: "/PlantViz_images/Vitviz_apps/DAPBrowse_banner.png",
                link: "http://plantaeviz.tomsbiolab.com:8004/vitis"
            },
            Conversions: {
                title: "Conversions App",
                description: "Convert between V3(V.Cost) and V1 gene ID annotations as well and append gene names and relevant info extracted from the grapevine reference gene catalogue provided as part of <a href='https://grapedia.org/genes/' target='_blank' style='color: blue'>Grapedia</a>.",
                image: "/PlantViz_images/Vitviz_apps/CONVERSIONS_banner.png",
                link: "http://plantaeviz.tomsbiolab.com/vitviz/conversions"
            },
            TransMetaDb: {
                title: "TransMeta Db",
                description: "The Transcriptomics & Metabolomics integrated database (TransMetaDb) can be used to explore the correlation between the expression of a list of genes of interest and different metabolites. For those correctly annotated experiments, there is also the option to integrate different studies, giving rise to more robust correlation analyses.",
                image: "/PlantViz_images/Vitviz_apps/TransMetaDB.png",
                link: "http://plantaeviz.tomsbiolab.com/vitviz/transmetadb"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genome, transcriptome and proteome using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4503"
            },
            ExpressionOntology: {
                title: "Expression Ontology",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "http://plantaeviz.tomsbiolab.com/vitviz/expression_ontology"
            }
        }
    },
    araviz: {
        logo: "/PlantViz_images/VitViz_logo.svg",
        header: "/PlantViz_images/AraViz_header.svg",
        color: "bg-araviz",
        url: "/araviz",
        text: "Arabidopsis thaliana",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Function associations represented as Gene Cards with references and all the information from the most recent version of the catalogue. Includes an interactive organ expression viewer thorough all SRA runs available.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "http://plantaeviz.tomsbiolab.com/araviz/catalogue"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use Expression Atlases App to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    beta_ionone_botrytis_atlas: {
                        name: "Beta ionone - botrytis atlas",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/beta_ionone_botrytis_atlas"
                    }
                }
            },
            non_agg_gcns: {
                title: "Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    cellculture: {
                        name: "cellculture",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/cellculture"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/root"
                    },
                    stem: {
                        name: "stem",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/stem"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/vasculature"
                    },
                    seedling: {
                        name: "seedling",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/seedling"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/flower"
                    },
                    fruit: {
                        name: "fruit",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/fruit"
                    },
                    bud: {
                        name: "bud",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/bud"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/seed"
                    },
                    embryo: {
                        name: "embryo",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/embryo"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/leaf"
                    },
                    CI: {
                        name: "CI",
                        link: "http://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/CI"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all SRA-Seq runs available in NCBI SRA database.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "http://plantaeviz.tomsbiolab.com/araviz/expacrossnetworks"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genome, transcriptome and proteome using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4501"
            },
            ExpressionOntology: {
                title: "Expression Ontology",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "http://plantaeviz.tomsbiolab.com/araviz/expression_ontology"
            }
        }
    },
    cannaviz: {
        logo: "/PlantViz_images/VitViz_logo.svg",
        header: "/PlantViz_images/CannaViz_header.svg",
        color: "bg-cannaviz",
        colorText: "text-black-50",
        url: "/cannaviz",
        text: "Cannabis sativa",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Function associations represented as Gene Cards with references and all the information from the most recent version of the catalogue. Includes an interactive organ expression viewer thorough all SRA runs available.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "http://plantaeviz.tomsbiolab.com/cannaviz/catalogue"
            },
            JL_non_agg_gcns: {
                title: "JL Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/root"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/flower"
                    },
                    bud: {
                        name: "bud",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/bud"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/seed"
                    },
                    CI: {
                        name: "CI",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/CI"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/leaf"
                    }
                }
            },
            PK_non_agg_gcns: {
                title: "PK Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    bud: {
                        name: "bud",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/bud"
                    },
                    CI: {
                        name: "CI",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/CI"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/seed"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/leaf"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/root"
                    },
                    trichomes: {
                        name: "trichomes",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/trichomes"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/flower"
                    }
                }
            },
            cbdrx_non_agg_gcns: {
                title: "cbdrx Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    trichomes: {
                        name: "trichomes",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/trichomes"
                    },
                    seed: {
                        name: "seed",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/seed"
                    },
                    leaf: {
                        name: "leaf",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/leaf"
                    },
                    root: {
                        name: "root",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/root"
                    },
                    bud: {
                        name: "bud",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/bud"
                    },
                    CI: {
                        name: "CI",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/CI"
                    },
                    flower: {
                        name: "flower",
                        link: "http://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/flower"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all SRA-Seq runs available in NCBI SRA database.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "http://plantaeviz.tomsbiolab.com/cannaviz/expacrossnetworks"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genome, transcriptome and proteome using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4504"
            },
            ExpressionOntology: {
                title: "Expression Ontology",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "http://plantaeviz.tomsbiolab.com/cannaviz/expression_ontology"
            }
        }
    }
}

export default Config;
